/**
 * Implementation of AppointmentNotificationStyles
 * This file contains styles for appointment notifications to ensure proper text contrast
 */

import styled from "styled-components";

export const NotificationWrapper = styled.div`
  position: fixed;
  top: 80px; /* Positioned below the header */
  right: 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  width: 320px;
  padding: 1rem;
  z-index: 1000;
  transform: translateX(${(props) => (props.show ? "0" : "120%")});
  transition: transform 0.3s ease-in-out;
  border: 1px solid rgba(33, 150, 243, 0.3); /* Light blue border */
`;

export const NotificationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid rgba(33, 150, 243, 0.2);
  padding-bottom: 0.5rem;

  h4 {
    margin: 0;
    color: #1976d2; /* Darker blue for better contrast */
    display: flex;
    align-items: center;
    font-size: 1rem;

    svg {
      margin-right: 0.5rem;
    }
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: #7f8c8d;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover {
      color: #2c3e50;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const NotificationContent = styled.div`
  p {
    margin: 0.5rem 0;
    font-size: 0.875rem;
    color: #333333; /* Dark text for good contrast on white background */
    line-height: 1.4;
  }

  .highlight {
    font-weight: 600;
    color: #1a1a1a; /* Almost black for highlighted text */
  }

  .appointment-details {
    background-color: #f0f7ff; /* Light blue background */
    padding: 0.75rem;
    border-radius: 5px;
    margin-top: 0.5rem;
    font-size: 0.8125rem;
    color: #333333; /* Dark text for good contrast */
    border: 1px solid rgba(33, 150, 243, 0.1);
  }

  .appointment-time {
    color: #1976d2; /* Darker blue for better contrast */
    font-weight: 500;
  }
`;
